export default "__VITE_ASSET__BBdNoJEM__"